var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._l((_vm.value),function(item){return _c('a-tag',{key:_vm._f("label")(item),attrs:{"color":"blue"}},[_vm._v(_vm._s(_vm._f("label")(item)))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }